import React, { useEffect, useState } from 'react';
import System from 'src/helper/system';
import Constants from 'src/helper/Constants';
import { BOM as Bom } from 'src/pages/BOM/BOM';
import { BomTabsList } from '../BOM/BomTabsList';
import { BomRematch } from '../BOM/BomRematch';
import { BomProductListing } from '../BOM/BomProductListing';
import Helper from 'src/helper/Helper';

export function BOM() {
    const [selectedTab, setSelectedTab] = useState('')
    const bomTabType = System.getParams().__c
    const { BomPages } = Constants

    useEffect(() => {
        setSelectedTab(bomTabType ? bomTabType : BomPages.CreateBom.param_value);
    }, [bomTabType])

    useEffect(() => {
        Helper.feedBackButtonScript()
    }, []);
    return (
        <div className="logged-screen">
            {selectedTab === BomPages.CreateBom.param_value && <Bom />}
            {selectedTab === BomPages.BomTabsList.param_value && <BomTabsList />}
            {selectedTab === BomPages.BomRematch.param_value && <BomRematch />}
            {selectedTab === BomPages.BomProductListing.param_value && <BomProductListing />}
            {selectedTab === BomPages.BomDetailById.param_value && <BomTabsList />}
        </div>
    );
}